<template>
  <div class="home-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <div>
          <el-button
            v-access:add
            icon="el-icon-plus"
            @click="add"
            size="small"
            :disabled="isloading"
            type="danger"
            >新增</el-button
          >
          <!--                    <el-button v-access:add-->
          <!--                               icon="el-icon-menu"-->
          <!--                               @click="centerDialogVisible = true"-->
          <!--                               size="small"-->
          <!--                               :disabled="isloading"-->
          <!--                    >预览</el-button>-->
        </div>
      </div>
      <div slot="searchBar">
        <of-search @search="search"></of-search>
      </div>
      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          v-loading="isloading"
          :max-height="tableMaxHeight()"
        >
          <el-table-column
            prop="Title"
            label="标题"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="Desc"
            label="描述"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column prop="CreateTime" label="创建时间" align="center">
            <template slot-scope="scope">
              {{ (scope.row.CreateTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column prop="PublishTime" label="发布时间" align="center">
            <template slot-scope="scope">
              {{ (scope.row.PublishTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Status"
            label="状态"
            :formatter="formatterStatus"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑
              </el-button>
              <el-button
                v-access:delete
                @click="innerDel(scope.row)"
                type="text"
                size="mini"
                >删除
              </el-button>
              <el-button
                v-if="scope.row.Status === 0"
                v-access:delete
                @click="pushMenu(scope.row)"
                type="text"
                size="mini"
                >发布
              </el-button>
              <el-button
                v-if="scope.row.Status === 1"
                v-access:delete
                @click="cancelPushMenu(scope.row)"
                type="text"
                size="mini"
                >取消发布
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="request.pageSize"
            :currentPage="request.pageIndex"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <el-dialog :visible.sync="centerDialogVisible" width="1080" center>
      <div class="appHome">
        <div class="app-header">
          <div class="app-logo">dgfdfg</div>
          <div class="app-time">ddfff</div>
        </div>
        <div class="app-banner">
          <div class="banner-box"></div>
        </div>
        <div class="app-menu">
          <div class="menu-box"></div>
        </div>
      </div>
    </el-dialog>
    <HomeSetEdit
      v-if="formVisible"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></HomeSetEdit>
  </div>
</template>
<script>
import BasePage from "@/components/base/of_page/of_page"
import OfPagination from "@/components/controls/of_pagination/of_pagination"
import OfSearch from "@/components/controls/of_search/of_search"
import api from "@/modules/zjrc/api"
import HomeSetEdit from "./edit"
export default {
  name: "list",
  components: {
    BasePage,
    OfPagination,
    OfSearch,
    HomeSetEdit,
  },
  data() {
    return {
      centerDialogVisible: false,
      isloading: false,
      listData: [],
      headerRow: "header-row",
      formTitle: "",
      formData: {},
      formVisible: false,
      total: 0,
      request: {
        pageIndex: 1,
        pageSize: 15,
        searchKey: "",
      },
    }
  },
  mounted() {
    this.loadData(1)
  },
  methods: {
    formCallBack(data) {
      this.formVisible = false
      if (data !== null) {
        this.loadData(1)
      }
    },
    search(keyword) {
      this.request.searchKey = keyword
      this.request.pageIndex = 1
      this.loadData(1)
    },
    add() {
      this.formTitle = "新增菜单"
      this.formData = {
        Sort: 0,
        PageType: 2,
        Type: 1,
        BackColor: "#000000",
        ShadowColor: "#000000",
      }
      this.formVisible = true
    },

    loadData(item) {
      let vm = this
      vm.isloading = true
      vm.request.pageIndex = item
      api.QueryHomeSetting(vm.request).then((res) => {
        if (res.data.Code === 0) {
          vm.total = res.data.Data.total
          vm.listData = res.data.Data.rows
        }
        vm.isloading = false
      })
    },
    tableMaxHeight() {
      const clientHeight = window.innerHeight
      let tableMaxHeight = 0
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 300
      }
      return tableMaxHeight
    },
    innerEdit(rowData) {
      this.formData = Object.assign({}, rowData)
      this.formTitle = "编辑菜单"
      this.formVisible = true
    },
    // 发布
    pushMenu(rowData) {
      this.$confirm("您确定发布？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          Id: rowData.Id,
          Status: 1,
        }
        api.PublishHomeSetting(params).then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "已发布",
              type: "success",
            })
            this.loadData(1)
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            })
          }
        })
      })
    },
    cancelPushMenu(rowData) {
      this.$confirm("您确定取消发布？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          Id: rowData.Id,
          Status: 0,
        }
        api.PublishHomeSetting(params).then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "已取消",
              type: "success",
            })
            this.loadData(1)
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            })
          }
        })
      })
    },
    //删除
    innerDel(rowData) {
      this.$confirm("您确定删除？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id }
        api.DeleteHomeSetting(params).then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "已删除",
              type: "success",
            })
            this.loadData(1)
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            })
          }
        })
      })
    },
    formatterStatus(item) {
      switch (item.Status) {
        case 0:
          return "未发布"
        case 1:
          return "已发布"
      }
    },
    handleSizeChange(val) {
      let vm = this
      vm.request.pageIndex = 1
      vm.request.pageSize = val
      vm.loadData(1)
    },
    handleCurrentChange(val) {
      if (this.total > this.request.pageSize) {
        this.request.pageIndex = val
        this.loadData(val)
      }
    },
  },
}
</script>
<style scoped lang="scss">
.appHome {
  width: 750px;
  height: 1333px;
  background: pink;
  margin: 0 auto;
  .app-header {
    width: 100%;
    height: 69px;
    background: #cccccc;
    display: flex;
  }
  .app-banner {
    padding: 30px;
    .banner-box {
      width: 688px;
      height: 404px;
      background: red;
    }
  }
  .app-menu {
    padding: 0 31px;
    .menu-box {
    }
  }
}
</style>
